'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What is Social Media Optimization (SMO) and why is it important?",
    answer: "SMO involves optimizing your social media profiles and content to increase visibility, engagement, and traffic. It’s crucial for building a strong brand presence, improving SEO, and encouraging meaningful interactions with your audience."
  },
  {
    question: "Which platforms do you optimize as part of your SMO services?",
    answer: "We optimize all major platforms including Facebook, Instagram, LinkedIn, Twitter, Pinterest, and YouTube. We tailor our approach based on your business goals and target audience."
  },
  {
    question: "What does the optimization process include?",
    answer: "Our SMO services include profile setup and enhancement, keyword-rich bios, visual branding, hashtag strategy, content scheduling, and consistent posting to improve performance and reach."
  },
  {
    question: "How will I know if SMO is working for my business?",
    answer: "We track metrics like profile visits, post engagement, follower growth, click-through rates, and social traffic to your website. You’ll receive detailed reports so you can monitor improvements and ROI."
  },
  {
    question: "Can you align my social media with my overall digital marketing strategy?",
    answer: "Absolutely. We ensure your social media presence supports your broader SEO, content, and advertising strategies — creating a cohesive brand experience across all digital channels."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div
        className="col text-center py-5 mt-5"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="500"
        data-aos-once="true"
      >
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
                      className={`transition-colors duration-200 cursor-pointer 
                        hover:text-purple-600 
                        ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
                    >{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
